var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUsermenuLogout = function SvgIconUsermenuLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "9388A341-827B-46EA-88E9-0044BDDF9FA4")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-menu",
    transform: "translate(-127.000000, -283.000000)",
    stroke: "#90949C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-usermenu-logout",
    transform: "translate(128.000000, 284.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3870865,4.82564268 C5.3870865,3.37021553 5.3870865,2.08490029 5.3870865,0.96969697 C5.3870865,0.434148121 5.81689314,0 6.3470865,0 L14.0270865,0 C14.5572799,0 14.9870865,0.434148121 14.9870865,0.96969697 L14.9870865,15.030303 C14.9870865,15.5658519 14.5572799,16 14.0270865,16 L6.3470865,16 C5.81689314,16 5.3870865,15.5658519 5.3870865,15.030303 L5.3870865,10.7860389",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-14",
    strokeLinejoin: "round",
    points: "3.25375317 4.26666667 0.0537531679 7.52882511 3.25375317 10.6666667"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 7.46666667,
    x2: 10.1870865,
    y2: 7.46666667,
    id: "Path-13",
    strokeLinejoin: "round"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUsermenuLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-usermenu-logout.a08095b7.svg";
export { ForwardRef as ReactComponent };